/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Image,
  Text,
  View,
  Alert,
  StyleSheet,
  ScrollView,
  Dimensions,
} from "react-native";
import _ from "lodash";
import colors from "@constants/color";
import Button from "@components/Button";
import RadioButton from "@components/RadioButton";
import { fontFamily } from "@utils/styles";
import PickupScheduleModal from "@screens/OrdersList/pickupScheduleModal";
import CustomModal from "@screens/OrdersList//CustomModal";
import { submitRvpTicketMultiple } from "@services/api";
import Warning2 from "@assets/svg/Warning2";
import SelectReasonCommentImgs from "./SelectReasonCommentImgs";
import {
  transformData,
  checkRequiredFields,
  shouldShowPickUpModal,
  getTotalQuantity,
} from "./utils";

const defObj = {
  image_upload: [],
  user_comment: "",
  quantity: 0,
};

const OrderItem = (props) => {
  const { rvpData = {}, navigation } = props;
  const {
    quantity = 1,
    options = [],
    default_option,
    product_image,
    short_name,
    order_item_id,
    order_id,
    possible_pickup_days,
    quantity_selection_text,
    choose_return_reason_text,
    price_after_discount,
    allow_scheduling,
    return_window_days,
    replacement_window_days,
    policy_time_over,
    policy_time_over_warning,
    policy_time_over_info,
  } = rvpData || {};
  const [toBeRaised, setToBeRaised] = useState({ REFUND: {} });
  const [reasons, setReasons] = useState([]);
  const [selectedReturnType, setSelectedReturnType] = useState(
    default_option && default_option.toUpperCase(),
  );
  const [returnTypes, setReturnTypes] = useState([]);
  const [modalContent, setModalContent] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showPickUpModal, setShowPickupSchedModal] = useState(false);
  const [pickUpDate, setPickUpDate] = useState(
    possible_pickup_days?.length > 1 ? "" : possible_pickup_days[0].date,
  );

  useEffect(() => {
    const types = options
      .filter((opt) => opt.enabled)
      .map((i) => {
        return { key: i.key, text: i.cta_text };
      });
    setReturnTypes(types);
  }, []);

  useEffect(() => {
    const selectedTypeOpts = options?.find(
      (opt) => opt.key === selectedReturnType,
    );
    setReasons(selectedTypeOpts.reasons);
    setModalContent(selectedTypeOpts.success);
  }, [options, selectedReturnType]);

  const onTypeChange = (key) => {
    setSelectedReturnType(key);
    setToBeRaised({ [key]: {} });
  };

  const onReasonChange = (key) => {
    const copyToBeRaised = JSON.parse(JSON.stringify(toBeRaised));
    if (_.has(copyToBeRaised, [selectedReturnType, key])) {
      _.unset(copyToBeRaised, [selectedReturnType, key]);
    } else {
      copyToBeRaised[selectedReturnType][key] = defObj;
    }
    setToBeRaised(copyToBeRaised);
  };

  const onQuantityChange = (key, value) => {
    const copyToBeRaised = JSON.parse(JSON.stringify(toBeRaised));
    const alreadySetTotalQuantity = getTotalQuantity(copyToBeRaised);
    const isCurrentLess =
      _.get(copyToBeRaised, [selectedReturnType, key, "quantity"]) < value;
    if (isCurrentLess && alreadySetTotalQuantity === quantity) return;
    key && _.set(copyToBeRaised, [selectedReturnType, key, "quantity"], value);
    setToBeRaised(copyToBeRaised);
  };

  const onCommentChange = (key, value) => {
    const copyToBeRaised = JSON.parse(JSON.stringify(toBeRaised));
    key &&
      _.set(copyToBeRaised, [selectedReturnType, key, "user_comment"], value);
    setToBeRaised(copyToBeRaised);
  };

  const onImageChange = (key, value) => {
    const copyToBeRaised = JSON.parse(JSON.stringify(toBeRaised));
    key &&
      _.set(copyToBeRaised, [selectedReturnType, key, "image_upload"], value);
    setToBeRaised(copyToBeRaised);
  };

  const getTransformedData = () =>
    transformData(order_id, order_item_id, toBeRaised, pickUpDate);

  const showAlert = (msg) => {
    Alert.alert(msg, "", [{ text: "OK", onPress: () => {} }]);
  };

  const shouldDisableSubmitBtn = () => {
    const requestsData = getTransformedData();
    const errors = checkRequiredFields(requestsData, reasons);
    return errors.length > 0;
  };

  const handleSubmitPress = () => {
    const requestsData = getTransformedData();
    const errors = checkRequiredFields(requestsData, reasons);
    if (errors.length > 0) {
      showAlert(errors[0]);
      return;
    }
    const showPickUpModalFn = shouldShowPickUpModal(
      requestsData,
      return_window_days,
      replacement_window_days,
      allow_scheduling,
      pickUpDate,
    );
    if (showPickUpModalFn) {
      setShowPickupSchedModal(true);
      return;
    }
    submitRvpTicketMultiple({ requests: requestsData })
      .then((res) => {
        setShowSuccessModal(true);
      })
      .catch((e) => {
        console.log("submitRvpTicket_err", e);
      });
  };

  return (
    <View style={{ height: Dimensions.get("window").height }}>
      <PickupScheduleModal
        visible={showPickUpModal}
        onPress={handleSubmitPress}
        selpickupDate={pickUpDate}
        setSelPickupDate={(date) => setPickUpDate(date)}
        pickupDays={
          possible_pickup_days
            ? possible_pickup_days.map((pickupDay) => ({
                text: pickupDay.date_text,
                key: pickupDay.date,
              }))
            : []
        }
        setShowModal={() => setShowPickupSchedModal(false)}
      />
      {showSuccessModal && modalContent?.heading_text ? (
        <CustomModal
          visible={showSuccessModal}
          heading={modalContent.heading_text}
          message={modalContent.message_text}
          buttons={[{ isApiHit: true, text: modalContent.cta_text }]}
          onPress={() => {
            setShowSuccessModal(false);
            navigation.goBack();
          }}
        />
      ) : null}
      <ScrollView>
        {policy_time_over ? (
          <View
            style={{
              marginHorizontal: 15,
              marginTop: 10,
              marginBottom: 5,
              padding: 15,
              borderWidth: 1,
              borderColor: "rgba(235, 174, 59, 0.5)",
              minHeight: 90,
              backgroundColor: "white",
              borderRadius: 6,
            }}
          >
            <View style={{ flexDirection: "row" }}>
              <Warning2 />
              <Text style={{ fontFamily: fontFamily.regular, marginLeft: 7 }}>
                {policy_time_over_warning}
              </Text>
            </View>
            <Text
              style={{
                fontFamily: fontFamily.regular,
                color: "rgba(0, 0, 0, 0.56)",
                marginTop: 6,
              }}
            >
              {policy_time_over_info}
            </Text>
          </View>
        ) : null}
        <View style={{ marginTop: 5, marginBottom: 24 }}>
          <View style={styles.mainContainer}>
            <View style={styles.headingContainer}>
              <Text style={styles.heading}>{quantity_selection_text}</Text>
            </View>
            <View style={styles.imageContainer}>
              <Image
                source={{ uri: product_image }}
                resizeMode="contain"
                style={{ height: 60, width: 60, marginRight: 10 }}
              />
              <View style={styles.productAndQtyContainer}>
                <View>
                  <Text style={styles.productName}>{short_name}</Text>
                  <View style={{ flexDirection: "row" }}>
                    <Text style={styles.price}>₹{price_after_discount}</Text>
                    <Text style={styles.qtyText}>{`Qty: ${quantity}`}</Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View>
            <View
              style={{
                backgroundColor: "white",
                paddingVertical: 5,
                marginVertical: 5,
              }}
            >
              <RadioButton
                radioOptions={returnTypes}
                default="REFUND"
                setSelectedOption={onTypeChange}
                color={colors.primary}
                radionButtonContainerStyle={{ flexDirection: "row" }}
                buttonContainerStyle={{ width: "50%" }}
              />
            </View>
          </View>
          {reasons ? (
            <View
              style={{
                backgroundColor: "white",
              }}
            >
              <View style={styles.headingContainer}>
                <Text style={styles.heading}>{choose_return_reason_text}</Text>
              </View>
              <SelectReasonCommentImgs
                rvpData={rvpData}
                reasons={reasons}
                toBeRaised={toBeRaised}
                selectedReturnType={selectedReturnType}
                setReason={(key) => {
                  onReasonChange(key);
                }}
                setQuantity={(key, qty) => {
                  onQuantityChange(key, qty);
                }}
                setImages={(key, imgs) => {
                  onImageChange(key, imgs);
                }}
                setComment={(key, user_comment) => {
                  onCommentChange(key, user_comment);
                }}
                color={colors.primary}
              />
            </View>
          ) : null}
        </View>
      </ScrollView>

      {reasons ? (
        <View style={styles.btnContainer}>
          <Button
            disabled={shouldDisableSubmitBtn()}
            buttonWidth="100%"
            borderRadius={10}
            btnText="सबमिट करें"
            buttonFontType="head2"
            height={56}
            onPress={() => handleSubmitPress()}
            containerStyle={{
              alignSelf: "center",
              marginVertical: 10,
              marginHorizontal: 16,
            }}
          />
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: "white",
  },
  headingContainer: {
    borderBottomWidth: 1,
    padding: 16,
    borderBottomColor: "rgba(0,0,0,0.1)",
    justifyContent: "center",
    backgroundColor: "white",
  },
  heading: { fontFamily: fontFamily.semiBold, fontSize: 16 },
  imageContainer: {
    flexDirection: "row",
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  productName: {
    fontSize: 16,
    fontFamily: fontFamily.regular,
  },
  productAndQtyContainer: {
    flexDirection: "row",
    flex: 1,
  },
  price: {
    fontSize: 16,
    fontFamily: fontFamily.semiBold,
    color: "rgba(0, 0, 0, 0.86)",
  },
  qtyText: {
    fontSize: 16,
    color: "rgba(0, 0, 0, 0.86)",
    marginLeft: 10,
  },
  btnContainer: {
    backgroundColor: "white",
    bottom: 0,
    position: "relative",
    height: 150,
    width: "100%",
    zIndex: 1000,
  },
});

export default OrderItem;
